import {
	Box,
	Button,
	Center,
	DrawerContent,
	DrawerFooter,
	DrawerHeader,
	Badge,
	VStack,
	HStack,
	Grid,
	Flex,
	Spacer,
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import React from "react";
import {
	getRaiderQuest,
	getQuestStatus,
	getTimeTillHome,
} from "../../../util/web3/interactQuests";
import {
	questIconResolver,
	questNameLookup,
	questRewardLookup,
} from "../../../util/helpers";
import { Raider } from "../../../types/raider";
import OnQuest from "../card/questing/OnQuest";
import Returning from "../card/questing/Returning";
import Returned from "../card/questing/Returned";

interface QuestDrawerProps {
	raider: Raider;
	closeDrawer: () => void;
}

export default function LeftDrawer(props: QuestDrawerProps) {
	const [raider] = useState<Raider>(props.raider);
	const [questName, setQuestName] = useState<string>("");
	const [questString, setQuestString] = useState<string>("");
	const [questStatus, setQuestStatus] = useState<number>(0); // 0 is None, 1 is Questing, 2 is Returning
	const [timeTillHome, setTimeTillHome] = useState<number>(0);
	const [questIcon, setQuestIcon] = useState<string>("");
	const [rewardName, setRewardName] = useState<string>("");

	useEffect(() => {
		const statusAndTimeHomeCheck = async (quest: string) => {
			const status = await getQuestStatus(Number(raider.id), quest);

			setQuestStatus(status);

			if (status == 2) {
				const timeHome = await getTimeTillHome(Number(raider.id), quest);
				setTimeTillHome(timeHome!);
			}
		};

		const fetchData = async () => {
			const quest = await getRaiderQuest(Number(raider.id));
			if (!quest) {
				throw "missing quest name!";
			} else {
				setQuestString(quest);
				setQuestName(questNameLookup(quest)!);
				setRewardName(questRewardLookup(quest)!);
				setQuestIcon(questIconResolver(quest)!);
				statusAndTimeHomeCheck(quest);
			}
		};

		fetchData();
	}, []);

	const infoPicker = () => {
		if (questStatus == 1) {
			return (
				<OnQuest
					raider={raider}
					questName={questName!}
					questIcon={questIcon!}
					rewardName={rewardName!}
					questString={questString!}
				/>
			);
		} else if (questStatus == 2 && timeTillHome! > 0) {
			return (
				<Returning
					raider={raider}
					questName={questName!}
					questIcon={questIcon!}
					rewardName={rewardName!}
					questString={questString!}
					timeTillHome={timeTillHome!}
				/>
			);
		} else if (questStatus == 2 && !(timeTillHome! > 0)) {
			return (
				<Returned
					raider={raider}
					questName={questName!}
					questIcon={questIcon!}
					rewardName={rewardName!}
					questString={questString!}
					timeTillHome={timeTillHome!}
				/>
			);
		}
	};

	return (
		<DrawerContent>
			<DrawerHeader background="gray.900">
				<Flex>
					<HStack>
						<VStack align={{ base: "flex-start", md: "left" }}>
							<Box>{raider.name}</Box>
							<Badge variant="outline">lvl. {raider.attributes[1].value}</Badge>
						</VStack>
					</HStack>
					<Spacer />
					<Grid templateColumns="repeat(1, 1fr)" gap={6}>
						<Center width="4rem" height="4rem" transform="scale(0.5)" mb={6}>
							{/* Raider image here TK */}
						</Center>
					</Grid>
				</Flex>
			</DrawerHeader>
			<Box mt="10px">{infoPicker()}</Box>

			<DrawerFooter justifyContent="left">
				<Button
					leftIcon={<FaArrowLeft />}
					color="red.100"
					onClick={() => props.closeDrawer()}
				>
					Back
				</Button>
			</DrawerFooter>
		</DrawerContent>
	);
}
